export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6247.e7c98abc.jpg";